import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SoilMoistureComponent } from './soilMoisture.component';
import { SharedModule } from '../shared/shared.module';

@NgModule({
  imports: [
    CommonModule,
    SharedModule
  ],
  declarations: [SoilMoistureComponent]
})
export class SoilMoistureModule { }
